import { render, staticRenderFns } from "./VendorInput.vue?vue&type=template&id=0fd1904c&scoped=true&"
import script from "./VendorInput.vue?vue&type=script&lang=js&"
export * from "./VendorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1904c",
  null
  
)

export default component.exports